import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

import type { ApiError, Maybe } from '@/lib/types';
import { INTL_PREFIX } from '@/messages/const';

const intlPrefix = `${INTL_PREFIX}.common`;

export const commonErrorCodeMessages = defineMessages({
  genericCheckoutError: {
    id: `${intlPrefix}.genericCheckoutError`,
    defaultMessage: 'Checkout error. Please try again later.',
  },
  genericPaymentError: {
    id: `${intlPrefix}.genericPaymentError`,
    defaultMessage: 'Payment error ({message}). Please try again later.',
  },
  genericPaymentErrorWithoutMessage: {
    id: `${intlPrefix}.genericPaymentError`,
    defaultMessage: 'Payment error. Please try again later.',
  },
  unexpectedErrorOccurred: {
    id: `${intlPrefix}.unexpectedErrorOccurred`,
    defaultMessage: 'Unexpected error occurred.',
  },
});
export type MessageValues = Record<string, any>;

export type FormattedError<Error extends ApiError> = {
  code: Error['code'];
  field?: Maybe<string>;
  message?: ApiError['message'] | MessageDescriptor;
  values?: MessageValues;
};

export type OutgoingFormattedError = FormattedError<ApiError> & {
  message: MessageDescriptor | string;
};

export type IncomingFormattedError = FormattedError<ApiError>;
